import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
const footerMainMenuItemStyles = () => css;
export const StyledFooterMainMenuItem = styled.li `
	${footerMainMenuItemStyles}
`;
const footerMainMenuItemLinkStyles = ({ theme }) => css `
	display: inline-block;
	text-decoration: none;
	color: ${theme.colors.base.textLink};

	&:hover,
	&:active {
		color: ${theme.colors.base.textBodyLinkHover};
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		border-radius: ${theme.borderRadius.m}px;
	}
`;
export const StyledFooterMainMenuItemLink = styled(Typography).attrs({
    variant: 'body-text',
    tagName: 'a',
}) `
	${footerMainMenuItemLinkStyles}
`;
